import _slicedToArray from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { jsxs as e, Fragment as t, jsx as n } from "react/jsx-runtime";
var a = function a(e) {
    return "amex" === e ? "17" : "dinersClub" === e ? "16" : "unionPay" === e ? "20" : "19";
  },
  l = function l(e) {
    return "mmyy" === e ? "5" : "mmddyy" === e ? "8" : "10";
  },
  r = function r(e, t, n, _r, c) {
    switch (t) {
      case "creditCard":
        return a(e);
      case "tel":
        return 12;
      case "date":
        return l(n);
      case "securityCode":
        return void 0 !== _r && "amex" !== _r && "other" !== _r ? 3 : 4;
      default:
        return c || "none";
    }
  },
  c = function c(e) {
    var t = e.target.selectionStart;
    return e.target.value.match(/[^0-9/\s/-]*/g).forEach(function (n, a) {
      "" !== n && (e.target.value = e.target.value.substring(0, a) + e.target.value.substring(a + 1, e.target.value.length), e.target.setSelectionRange(t - 1, t - 1));
    }), e.target.value;
  },
  h = function h(e) {
    var t = e.target.selectionStart;
    return e.target.value.match(/[^0-9]*/g).forEach(function (n, a) {
      "" !== n && (e.target.value = e.target.value.substring(0, a) + e.target.value.substring(a + 1, e.target.value.length), e.target.setSelectionRange(t - 1, t - 1));
    }), e.target.value;
  },
  d = function d(e, t) {
    if (!e) return;
    var n = e.substring(e.length - 4);
    var a = "";
    var l = e.replace(/\D/g, "").length - 4;
    if (e.length > 13) {
      for (; a.length < 2 * l;) a += "• ";
      a += n;
    }
    return a;
  },
  g = function g(e) {
    var t;
    return t = e.length < 5 ? e.match(/^(\d{1,4})$/) : e.length < 9 ? e.match(/^(\d{4})(\d{1,4})$/) : e.length < 13 ? e.match(/^(\d{4})(\d{4})(\d{1,4})$/) : e.match(/^(\d{4})(\d{4})(\d{4})(\d{1,4})$/), t;
  },
  s = function s(e, t) {
    var n, a;
    var l = parseInt(t.substring(0, 1), 10),
      r = parseInt(t.substring(0, 2), 10),
      c = parseInt(t.substring(0, 3), 10),
      h = parseInt(t.substring(0, 4), 10),
      d = parseInt(t.substring(0, 6), 10);
    return 4 === l ? (a = t.length < 5 ? t.match(/^(\d{1,4})$/) : t.length < 9 ? t.match(/^(\d{4})(\d{1,4})$/) : t.length < 13 ? t.match(/^(\d{4})(\d{4})(\d{1,4})$/) : t.match(/^(\d{4})(\d{4})(\d{4})(\d{1,7})$/), n = "visa") : 34 === r || 37 === r ? (a = t.length < 5 ? t.match(/^(\d{1,4})$/) : t.length < 11 ? t.match(/^(\d{4})(\d{1,6})$/) : t.match(/^(\d{4})(\d{6})(\d{1,5})$/), n = "amex") : 62 === r || 81 === r || 60 === r && 6011 !== h ? (t.length < 5 ? a = t.match(/^(\d{1,4})$/) : t.length < 9 ? a = t.match(/^(\d{4})(\d{1,4})$/) : t.length < 13 ? a = t.match(/^(\d{4})(\d{4})(\d{1,4})$/) : t.length < 17 ? a = t.match(/^(\d{4})(\d{4})(\d{4})(\d{1,4})$/) : 17 === t.length || 18 === t.length ? a = t.match(/^(\d{1,18})$/) : 19 === t.length && (a = t.match(/^(\d{6})(\d{1,13})$/)), n = "unionPay") : c > 299 && c <= 305 || 309 === c || 36 === r || 38 === r || 39 === r ? (a = t.length < 5 ? t.match(/^(\d{1,4})$/) : t.length < 11 ? t.match(/^(\d{4})(\d{1,6})$/) : t.match(/^(\d{4})(\d{6})(\d{1,4})$/), n = "dinersClub") : 6011 === h || c >= 644 && c <= 649 || 65 === r ? (a = g(t), n = "discover") : h >= 3528 && h <= 3589 ? (a = g(t), n = "jcb") : r >= 51 && r <= 55 || d >= 222100 && d <= 272099 ? (a = g(t), n = "mastercard") : t.length < 6 ? (a = g(t), n = "placeholder") : (a = g(t), n = "generic"), {
      match: a,
      cardType: n
    };
  },
  u = function u(e, t) {
    var n = e.target.value,
      a = e.target.selectionStart;
    e.target.selectionEnd;
    var l = n.replace(/\D/g, ""),
      r = s(0, l),
      _r2 = r,
      c = _r2.cardType;
    " " === n[a - 1] && a < n.length ? a -= 1 : void 0 === t || t.length < n.length ? "amex" === c || "dinersClub" === c ? 5 !== a && 12 !== a || (a += 1) : a % 5 == 0 && a < 16 && (a += 1) : t.length > n.length && " " === t[a] && (n = n.slice(0, a - 1) + n.slice(a, n.length), a -= 1), l = n.replace(/\D/g, ""), r = s(0, l);
    var _r3 = r,
      h = _r3.match;
    return h && h[4] ? e.target.value = "".concat(h[1], " ").concat(h[2], " ").concat(h[3], " ").concat(h[4]) : h && h[3] ? e.target.value = "".concat(h[1], " ").concat(h[2], " ").concat(h[3]) : h && h[2] ? e.target.value = "".concat(h[1], " ").concat(h[2]) : h && h[1] ? e.target.value = h[1] : c = "placeholder", {
      value: e.target.value.replace(/[^0-9\s]*/g, ""),
      cardType: c
    };
  },
  i = function i(e) {
    var t;
    return e.length > 6 ? t = e.match(/^(\d{3})(\d{3})(\d{1,4})$/) : e.length > 3 ? t = e.match(/^(\d{3})(\d{1,3})$/) : e.length > 0 && (t = e.match(/^\d{1,3}$/)), t;
  },
  $ = function $(e, t) {
    var n = e;
    t && t[3] ? n.value = "".concat(t[1], "-").concat(t[2], "-").concat(t[3]) : t && t[2] ? 3 === t[2].length ? n.value = "".concat(t[1], "-").concat(t[2], "-") : n.value = "".concat(t[1], "-").concat(t[2]) : t ? 3 === t[0].length ? n.value = "".concat(t[0], "-") : n.value = t[0] : n.value = "";
  },
  m = function m(e, t) {
    var n = e,
      a = t;
    return n += 1, a += 1, [n, a];
  },
  o = function o(e, t) {
    var n = e,
      a = t;
    return n -= 1, a -= 1, [n, a];
  },
  v = function v(e, t) {
    var _m, _m2, _m3, _m4, _m5, _m6, _o3, _o4;
    var n = e.target,
      a = n.value.replace(/\D/g, ""),
      l = t.replace(/\D/g, "");
    var r,
      c = n.selectionStart,
      h = n.selectionEnd;
    if (t.length > n.value.length && "-" === t[c]) {
      var _o, _o2;
      n.value = n.value.slice(0, c - 1) + n.value.slice(c, n.value.length);
      var _e = n.value.replace(/\D/g, "");
      r = i(_e), _o = o(c, h), _o2 = _slicedToArray(_o, 2), c = _o2[0], h = _o2[1], _o, $(n, r);
    } else if (a.length <= l.length) {
      var _e2 = n.value.substring(0, n.selectionStart) + n.value.slice(n.selectionStart, n.value.length);
      _e2 = _e2.replace(/\D/g, ""), r = i(_e2), $(n, r);
    } else a.length > l.length ? (r = i(a), r && r[3] ? (n.value = "".concat(r[1], "-").concat(r[2], "-").concat(r[3]), 4 !== c && 8 !== c || (_m = m(c, h), _m2 = _slicedToArray(_m, 2), c = _m2[0], h = _m2[1], _m)) : r && r[2] ? (n.value.length >= 7 ? n.value = "".concat(r[1], "-").concat(r[2], "-") : n.value = "".concat(r[1], "-").concat(r[2]), 4 !== c && 7 !== c || (_m3 = m(c, h), _m4 = _slicedToArray(_m3, 2), c = _m4[0], h = _m4[1], _m3)) : r ? (n.value.length >= 3 ? n.value = "".concat(r[0], "-") : n.value = r[0], 3 === c && (_m5 = m(c, h), _m6 = _slicedToArray(_m5, 2), c = _m6[0], h = _m6[1], _m5)) : n.value = "") : (r = i(l), $(n, r), _o3 = o(c, h), _o4 = _slicedToArray(_o3, 2), c = _o4[0], h = _o4[1], _o3);
    return n.setSelectionRange(c, h), {
      value: n.value
    };
  },
  p = function p(e) {
    var t = e.toString().replace(/[^0-9]+/g, "").slice(0, 10);
    var n;
    return t.length > 6 ? n = t.replace(/^(\d{3})(\d{3})(\d{1,4})$/, "$1-$2-$3") : (6 === t.length || t.length < 6 && t.length > 0) && (n = t.replace(/^(\d{3})(\d{1,3})$/, "$1-$2-")), n;
  },
  Y = function Y(e, t, n) {
    var a;
    return a = "mmddyy" === n ? t.length < 3 ? t.match(/^(\d{1,2})$/) : t.length < 5 ? t.match(/^(\d{2})(\d{1,2})$/) : t.match(/^(\d{2})(\d{2})(\d{1,2})$/) : "mmddyyyy" === n ? t.length < 3 ? t.match(/^(\d{1,2})$/) : t.length < 5 ? t.match(/^(\d{2})(\d{1,2})$/) : t.match(/^(\d{2})(\d{2})(\d{1,4})$/) : t.length < 3 ? t.match(/^(\d{1,2})$/) : t.match(/^(\d{2})(\d{1,2})$/), {
      match: a
    };
  },
  f = function f(e) {
    var t = "";
    return 1 === e.length ? t = /^([01])$/.test(e) ? e : "" : 2 === e.length && (t = /^(0[1-9]|1[0-2])$/.test(e) ? e : e[0]), t;
  },
  y = function y(e) {
    var t = "";
    return 1 === e.length ? t = /^([0-3])$/.test(e) ? e : "" : 2 === e.length && (t = /^(0[1-9]|[12][0-9]|3[01])$/.test(e) ? e : e[0]), t;
  },
  D = function D(e, t, n) {
    var a = e.target.value.replace(/\D/g, ""),
      l = e.target.selectionEnd,
      r = e.target.selectionStart;
    t.replace(/\D/g, "").length < a.length ? 3 !== r && 6 !== r || (r += 1, l += 1) : 2 !== r && 5 !== r || (e.target.value = e.target.value.slice(0, r - 1) + e.target.value.slice(r, e.target.value.length), r -= 1, l -= 1), a = e.target.value.replace(/\D/g, "");
    var c = Y(0, a, n),
      h = c.match;
    return "mmddyy" === n || "mmddyyyy" === n ? h && h[3] ? e.target.value = "".concat(h[1], "/").concat(h[2], "/").concat(h[3]) : h && h[2] ? e.target.value = "".concat(h[1], "/").concat(y(h[2])) : h && h[1] && (e.target.value = f(h[1])) : h && h[2] ? e.target.value = "".concat(h[1], "/").concat(h[2]) : h && h[1] && (e.target.value = f(h[1])), e.target.setSelectionRange(r, l), {
      value: e.target.value.replace(/[^0-9/\s]*/g, "")
    };
  },
  b = function b(a, l) {
    var r = l.replace(/\D/g, ""),
      c = r.charAt(0),
      h = r.charAt(1),
      d = r.charAt(2),
      g = r.charAt(3),
      s = r.charAt(4),
      u = r.charAt(5),
      i = r.charAt(6),
      $ = r.charAt(7);
    switch (a) {
      case "mmyy":
        return g ? e("span", {
          children: [c, h, "/", d, g]
        }) : d ? e(t, {
          children: [e("span", {
            children: [c, h, "/", d]
          }), "Y"]
        }) : h ? e(t, {
          children: [e("span", {
            children: [c, h]
          }), n("span", {
            className: "slash",
            children: "/"
          }), "YY"]
        }) : c ? e(t, {
          children: [n("span", {
            children: c
          }), "M/YY"]
        }) : "MM/YY";
      case "mmddyy":
        return u ? e("span", {
          children: [c, h, "/", d, g, "/", s, u]
        }) : s ? e(t, {
          children: [e("span", {
            children: [c, h, "/", d, g, "/", s]
          }), "Y"]
        }) : g ? e(t, {
          children: [e("span", {
            children: [c, h, "/", d, g]
          }), n("span", {
            className: "slash",
            children: "/"
          }), "YY"]
        }) : d ? e(t, {
          children: [e("span", {
            children: [c, h, "/", d]
          }), "D/YY"]
        }) : h ? e(t, {
          children: [e("span", {
            children: [c, h]
          }), n("span", {
            className: "slash",
            children: "/"
          }), "DD/YY"]
        }) : c ? e(t, {
          children: [n("span", {
            children: c
          }), "M/DD/YY"]
        }) : "MM/DD/YY";
      default:
        return $ ? e("span", {
          children: [c, h, "/", d, g, "/", s, u, i, $]
        }) : i ? e(t, {
          children: [e("span", {
            children: [c, h, "/", d, g, "/", s, u, i]
          }), "Y"]
        }) : u ? e(t, {
          children: [e("span", {
            children: [c, h, "/", d, g, "/", s, u]
          }), "YY"]
        }) : s ? e(t, {
          children: [e("span", {
            children: [c, h, "/", d, g, "/", s]
          }), "YYY"]
        }) : g ? e(t, {
          children: [e("span", {
            children: [c, h, "/", d, g]
          }), n("span", {
            className: "slash",
            children: "/"
          }), "YYYY"]
        }) : d ? e(t, {
          children: [e("span", {
            children: [c, h, "/", d]
          }), "D/YYYY"]
        }) : h ? e(t, {
          children: [e("span", {
            children: [c, h]
          }), n("span", {
            className: "slash",
            children: "/"
          }), "DD/YYYY"]
        }) : c ? e(t, {
          children: [n("span", {
            children: c
          }), "M/DD/YYYY"]
        }) : "MM/DD/YYYY";
    }
  };
export { a as _calculateCCMaxLength, l as _calculateDateMaxLength, y as _checkDateValue, f as _checkMonthValue, s as _determineCard, p as _formatOnLoad, v as _formatToPhoneDash, Y as _handleDate, c as _ignoreAlpha, d as _maskValue, h as _onlyNumbers, u as creditCardOnChange, D as dateOnChange, r as determineMaxLength, b as stickyPlaceholderHTML };